module.exports = __webpack_public_path__ + "static/media/YB5F09_1.db3fae93.jpg";